export const qrCodeFormatValidator = (qrCode) => (/^\d{13}(-[a-z]+)?$/.test(qrCode));

export default qrCodeFormatValidator;
